<div class="workspaces-tab-container">
    <div class="table-container">
        <div class="table-header">
            <h2 class="table-title">Workspaces</h2>
            <span matTooltip="Data lake and landing zone required for workspace creation." [matTooltipDisabled]="hasDatalake() && hasLandingZone()">
                <button mat-fab extended class="add-button" 
                        matTooltip="Add new workspace"
                        [disabled]="workspaceService.isWorkspaceLoading() || !hasDatalake() || !hasLandingZone()"
                    (click)="openAddWorkspaceDialog()">
                <mat-icon>add</mat-icon>Add Workspace</button>
            </span>
        </div>
        <div class="table-body">
            @if (workspaceService.isWorkspaceLoading()) {
                <app-loading-spinner/>
            } @else if (workspaceService.workspaceErrorMessage() === "") {
                <table mat-table [dataSource]="workspacesDataSource" matSort class="table">
                    <ng-container matColumnDef="workspaceName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-header">Name</th>
                        <td mat-cell *matCellDef="let element" class="name-column">
                            {{element.workspaceName}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="workspaceAlias">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-header">Alias</th>
                        <td mat-cell *matCellDef="let element" class="alias-column">
                            <span [class.empty-table-field]="!element.workspaceAlias">
                                {{element.workspaceAlias || "-"}}
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="networkAccess">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-header">Network Access</th>
                        <td mat-cell *matCellDef="let element" class="access-column">
                            @if (element.publicNetworkAccess === networkAccessEnum.Enabled) {
                                <div class="public-network-access-message">
                                    <div class="icon-container"><mat-icon>public</mat-icon></div>
                                    Public Access
                                </div>
                            } @else if (element.publicNetworkAccess === networkAccessEnum.Disabled) {
                                <div class="private-network-access-message">
                                    <div class="icon-container"><mat-icon>vpn_lock</mat-icon></div>
                                    Private Access
                                </div>
                            } @else {
                                <span class="empty-table-field">{{"-"}}</span>
                            }
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="creationDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-header">Date Created</th>
                        <td mat-cell *matCellDef="let element" class="creation-date-column">
                            @if (element.createdDateTime) {
                                {{element.createdDateTime | date:'dd MMM yyyy, HH:mm'}}
                            } @else {
                                <span class="empty-table-field">{{"-"}}</span>
                            }
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="provisionStatus">
                        <th mat-header-cell *matHeaderCellDef class="column-header"></th>
                        <td mat-cell *matCellDef="let element" class="status-column">
                            <div class="icon-container">
                                @if (successStatusEnum.includes(element.provisionStatus)) {
                                    <span matTooltip="Edit Workspace" matTooltipDisabled="false">
                                        <button mat-icon-button
                                            class="edit-button"
                                            (click)="openEditWorkspaceDialog(element)">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                    </span>
                                } @else if (creatingStatusEnum.includes(element.provisionStatus)) {
                                    <div class="loading"><app-loading-spinner [strokeWidth]="2" [diameter]="25"></app-loading-spinner></div>
                                } @else if (failureStatusEnum.includes(element.provisionStatus)) {
                                    <button disabled mat-icon-button
                                        class="error-button">
                                        <mat-icon>error_outline</mat-icon>
                                    </button>
                                } @else {
                                    <span matTooltip="Unknown Status" matTooltipDisabled="false">
                                        <button disabled mat-icon-button
                                            class="edit-button">
                                            <mat-icon>help_outline</mat-icon>
                                        </button>
                                    </span>
                                }
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="workspaceColumns ; sticky: true" class="header-row"></tr>
                    <tr mat-row *matRowDef="let row; columns: workspaceColumns;" class="row"></tr>

                    @if (hasDatalake() && hasLandingZone()) {
                        <tr class="full-row" *matNoDataRow>
                            <td [attr.colspan]="workspaceColumns.length" class="full-row-cell">
                                <div class="full-row-content">
                                    <mat-icon>info</mat-icon>
                                    <p class="not-found-message">No Workspaces Found</p>
                                    <p class="not-found-sub-message">To create a workspace, click Add Workspace</p>
                                </div>
                            </td>
                        </tr>
                    } @else {
                        <tr class="full-row" *matNoDataRow>
                            <td [attr.colspan]="workspaceColumns.length" class="full-row-cell">
                                <div class="full-row-content">
                                    <mat-icon>info</mat-icon>
                                    <p class="not-found-message">Unable to Create Workspaces</p>
                                    <p class="not-found-sub-message">Workspace creation requires at least one data lake and at least one landing zone</p>
                                </div>
                            </td>
                        </tr>
                    }
                </table>
            } @else {
                <tr class="error-container">
                    <mat-icon>warning</mat-icon>
                    <p class="error-message">Error: {{workspaceService.workspaceErrorMessage()}}</p>
                </tr>
            }
        </div>
    </div>
</div>